import React from 'react';
import { FUNDING_CLIENT_STATUSES } from '../../utils/funding/constants';

const STATUS_STYLES = {
  Draft: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200',
  'Missing Information': 'bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-200',
  'Documents Pending': 'bg-orange-50 text-orange-800 dark:bg-orange-950/40 dark:text-orange-200',
  'Ready for Analysis': 'bg-[var(--fg-accent-soft)] text-[var(--fg-accent)]',
  'Analysis Complete': 'bg-sky-50 text-sky-800 dark:bg-sky-950/40 dark:text-sky-200',
  Submitted: 'bg-indigo-50 text-indigo-800 dark:bg-indigo-950/40 dark:text-indigo-200',
  Funded: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200',
  'Not Qualified': 'bg-rose-50 text-rose-800 dark:bg-rose-950/40 dark:text-rose-200',
};

const FundingClientStatusBadge = ({ status }) => {
  const label = FUNDING_CLIENT_STATUSES.includes(status) ? status : 'Draft';
  const className = STATUS_STYLES[label] || STATUS_STYLES.Draft;

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${className}`}>
      {label}
    </span>
  );
};

export default FundingClientStatusBadge;
